import { AxiosResponse } from 'axios';

import { RecordingsSeasonsResponse } from 'store/railsBuilder/reducer.types';

function isRecordingsSeasonsResponse(
    response: any,
): response is AxiosResponse<RecordingsSeasonsResponse> {
    return Array.isArray(response?.data?.seasons);
}

export default isRecordingsSeasonsResponse;
